<nav class="page-nav">
  @for (item of items(); track item.targetId) {
    <a href="javascript:void(0)" (click)="onItemClick(item)">
      <htx-icon [icon]="item.icon"></htx-icon>
      {{ item.label }}
    </a>
  }
</nav>
